import { render } from "./MasterListDetail.vue?vue&type=template&id=72952ca1&scoped=true"
import script from "./MasterListDetail.vue?vue&type=script&lang=js"
export * from "./MasterListDetail.vue?vue&type=script&lang=js"

import "./MasterListDetail.vue?vue&type=style&index=0&id=72952ca1&scoped=true&lang=css"
import "./MasterListDetail.vue?vue&type=style&index=1&id=72952ca1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72952ca1"]])

export default __exports__